"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var imageHtml = {
  html: function html(alt, url) {
    return "<div>\n              <div>\n                <div class=\"responsive-image__wrapper\">\n                  <img class=\"responsive-image__image\"\n                    src=\"" + url + "\"\n                    alt=\"" + alt + "\"\n                    tabindex=\"-1\">\n                </div>\n              </div>\n            </div>";
  }
};

exports.default = imageHtml;